import { useState, DragEvent, ReactNode } from 'react';
import './DragDropArea.scss';

interface DragDropAreaProps {
  onFileDrop?: (file: File) => void;
  disabled?: boolean;
  children: ReactNode;
  className?: string;
}

export const DragDropArea = ({
  onFileDrop,
  disabled = false,
  children,
  className = '',
}: DragDropAreaProps) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const updateDragState = (newState: boolean) => {
    setIsDragOver(newState);
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && onFileDrop) {
      updateDragState(true);
    }
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    updateDragState(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    updateDragState(false);

    if (disabled || !onFileDrop) {
      return;
    }

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      onFileDrop(files[0]);
    }
  };

  const containerClasses = [
    'drag-drop-area',
    className,
    isDragOver ? 'drag-over' : '',
    disabled ? 'disabled' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={containerClasses}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
    </div>
  );
};
